/**
 * @desc 业务端请求报告
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(
  body: defs.platDataFlow.AmazonReportRemovalShipmentRequestParamsDto,
  options?: any,
) {
  return updateResponse(
    http(URL + `/getReportList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
